<template>
  <div class="wallet-container">
    <div class="header">
      <div class="balance-section">
        <!-- <div class="item">
          <div class="label">我的余额</div>
          <div class="value">¥{{ balance }}</div>
        </div> -->
        <div class="item">
          <div class="label">{{ $t('page.users.wallet.cumulativeSpending') }}</div>
          <div class="value">{{ GLOBAL.shopPayCurrency }}{{ totalSpending }}</div>
        </div>
      </div>
    </div>

    <div class="records-section" v-loading="loading">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t(`page.users.wallet.all`)" name=""></el-tab-pane>
        <!-- <el-tab-pane :label="$t(`page.users.wallet.income`)" name="2"></el-tab-pane> -->
        <el-tab-pane :label="$t(`page.users.wallet.spending`)" name="1"></el-tab-pane>
      </el-tabs>

      <el-table :data="tableData" style="width: 100%" class="record-table">
        <el-table-column prop="cate" :label="$t(`page.users.wallet.tableColumn.type`)" width="280"></el-table-column>
        <el-table-column prop="money" :label="$t(`page.users.wallet.tableColumn.amount`)" width="280">
          <!-- <template slot-scope="scope">
            <span :class="scope.row.amount > 0 ? 'positive' : 'negative'">
              {{ scope.row.amount > 0 ? '+' : '' }}{{ scope.row.amount.toFixed(2) }}
            </span>
          </template> -->
        </el-table-column>
        <el-table-column prop="addtime" :label="$t(`page.users.wallet.tableColumn.time`)">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WalletPage',
  head() {
    return {
      title: this.$t(`page.users.wallet.navTitle`)
    }
  },
  data() {
    return {
      balance: 0,
      totalSpending: 0,
      activeName: '',
      loading: false,
      tableData: []
    }
  },
  mounted() {
    this.getWalletList();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      this.page = 1
      this.getWalletList()
    },
    getWalletList() {
      this.loading = true
      this.$axios.post('/api/center/getMoneyList', {
        page: this.currentPage,
        pageSize: 10,
        type: this.activeName
      }).then(res => {
        console.log(res)
        this.tableData = res.data?.list?.map(item => {
          return {
            cate: item.cate,
            money: item.money ? this.GLOBAL.shopPayCurrency + item.money : 0,
            addtime: item.addtime
          }
        });
        this.totalSpending = res.data?.total_money || 0
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wallet-container {
  background-color: #f5f5f5;
  padding: 20px;
}

.header {
  background: linear-gradient(to right, #f05a46, #f78c53);
  border-radius: 8px;
  padding: 30px;
  color: #fff;
  margin-bottom: 20px;

  .balance-section {
    display: flex;
    justify-content: space-around;
    text-align: center;

    .item {
      .label {
        font-size: 14px;
        margin-bottom: 10px;
      }

      .value {
        font-size: 32px;
        font-weight: bold;
      }
    }
  }
}

.records-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;

  .record-table {
    margin-top: 20px;

    .positive {
      color: #f05a46;
    }

    .negative {
      color: #333;
    }
  }
}

::v-deep .el-tabs__item.is-active {
  color: #f05a46;
}

::v-deep .el-tabs__active-bar {
  background-color: #f05a46;
}

::v-deep .el-tabs__item:hover {
  color: #f05a46;
}
</style>
